/**
 * Avatar fallback initials for a user when no avatar image is available.
 *
 * Used by every note-style surface (Notes thread, sibling notes,
 * drawer composer). Kept here so all three render identical initials
 * for the same author.
 */
export const initialsOf = (
  name?: string | null,
  email?: string | null,
): string => {
  if (name && name.trim()) {
    const parts = name.trim().split(/\s+/)
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
  }
  if (email) return email.slice(0, 2).toUpperCase()
  return '??'
}
